import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class TopMarginService {
	constructor(private httpclientService: HttpclientService) {}
	loadTopMarginList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/TopMarginGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
